import { useState } from 'react';
import { createContainer } from 'unstated-next';

export function useAddonHook() {
  const [isAddon, setIsAddon] = useState(false);
  return { isAddon, setIsAddon };
}

const AddonContainer = createContainer(useAddonHook);

export default AddonContainer;
